import { render, staticRenderFns } from "./BudgetPerCategory.vue?vue&type=template&id=b8c6f308&"
import script from "./BudgetPerCategory.vue?vue&type=script&lang=js&"
export * from "./BudgetPerCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8c6f308')) {
      api.createRecord('b8c6f308', component.options)
    } else {
      api.reload('b8c6f308', component.options)
    }
    module.hot.accept("./BudgetPerCategory.vue?vue&type=template&id=b8c6f308&", function () {
      api.rerender('b8c6f308', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Budget/BudgetPerCategory.vue"
export default component.exports